import url from './url'
const AppConsts= {
    userManagement:{
        defaultAdminUserName: 'admin'
    },
    localization:{
        defaultLocalizationSourceName: 'tendyc'
    },
    authorization:{
        encrptedAuthTokenName: 'enc_auth_token'
    },
    setting: {
        shrink: false,
        confirmLeave: false,
        nroTabs: 7,
        timeout: 480000,
        appName: 'Tendyc',
    },
    appBaseUrl: "http://localhost:8080",
    remoteServiceBaseUrl: url

}
export default AppConsts